<template>
  <CustomBadge :bgColor="bgColor" :text="displayText" />
</template>

<script setup lang="ts">
import { defineProps, computed } from "vue";
import CustomBadge from "./CustomBadge.vue";

const props = defineProps({
  isPositive: {
    type: Boolean,
  },
  isZero: {
    type: Boolean,
  },
  percentage: {
    type: String,
    required: true,
  },
});

const bgColor = computed(() => (props.isPositive ? "bg-green" : "bg-red"));

const displayText = computed(() => {
  return (
    (props.isZero ? "" : props.isPositive ? "+" : "-") + props.percentage + "%"
  );
});
</script>
